import React from 'react';
import propTypes from 'prop-types';

import { getMessage , getCropBasedMessage } from 'util/locale';

import { Table } from '@tcc/crate';
import CustomCell from 'edit/seed-product-selector/SeedProductResultsListCell';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

const baseString = 'vra-seed-product-results-list-container';

const SeedProductResultsList = ({
  activeSeedProductIds,
  canSelectMoreResults,
  onToggleSeedProduct,
  searchResults
}) => {

  const onSelect = ({ id }) => { onToggleSeedProduct(id); };
  const cropId = useSelector(getActiveCropId);

  const colWidth = {
    'brand': 190,
    'name': 100,
    'rm': 50
  };
  const colHeads = ['brand', 'name' , 'rm'].map((col) => {
    const isNameCol = col === 'name';
    return {
      cellWidth: colWidth[col],
      columnKey: col,
      title: isNameCol 
        ? getCropBasedMessage({ key: `title-text__seed-finder-results-col--${col}`, cropId })
        : getMessage(`title-text__seed-finder-results-col--${col}`)
    };
  });
  
  const tableData = searchResults.map(({ brand, id, name, rm }) => {
    const isSelected = activeSeedProductIds.includes(id);
    const isDisabled = !isSelected && !canSelectMoreResults;
  
    return {
      brand,
      id,
      isDisabled,
      isSelected,
      name,
      onSelect,
      rm
    };
  });

  let selectStatusMessage;
  
  switch (activeSeedProductIds.length) {
    case 0:
      selectStatusMessage = getMessage(`text__seed-finder-select-status-0.${cropId}`);
      break;
    case 1:
      selectStatusMessage = getMessage(`text__seed-finder-select-status-1.${cropId}`);
      break;
    default:
      selectStatusMessage = getMessage(`text__seed-finder-select-status-other.${cropId}`);
      break;
  }
  
  return (
    <section className={baseString}>
      <header className={`${baseString}__header`}>
        {getMessage(`title-text__seed-finder-results.${cropId}`, { num: searchResults.length })}
        <span>
          {selectStatusMessage}
        </span>
      </header>
      <div className={`${baseString}__table-wrapper`}>
        <Table
          className={`${baseString}__table`}
          columnNames={colHeads}
          data={tableData}
          testId={`${baseString}__table`}
        >
          <CustomCell cellWidth={colWidth.brand}/>
          <CustomCell cellWidth={colWidth.name}/>
          <CustomCell cellWidth={colWidth.rm}/>
        </Table>
      </div>
    </section>
  );
};
  
SeedProductResultsList.propTypes = {
  activeSeedProductIds: propTypes.array.isRequired,
  canSelectMoreResults: propTypes.bool.isRequired,
  onToggleSeedProduct: propTypes.func.isRequired,
  searchResults: propTypes.array,
  searchResultsSort: propTypes.object
};

export default SeedProductResultsList;